module.exports = __webpack_public_path__ + "slogan.png?65c1a76cf6572949fdf74979133c6cf6";


//////////////////
// WEBPACK FOOTER
// ./src/assets/slogan.png
// module id = 139
// module chunks = 0